export default __webpack_public_path__ + "static/media/earth-1756274.0ed5dc2c.jpg";